import { Combobox } from '@/components/combobox'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import type { Role } from './types'

interface Props {
  title: string
  roleFilter: Role | null
  onRoleFilterChange: (value: Role | null) => void
}

const ALL_ROLES_VALUE = '__all__'
type RoleSelectValue = typeof ALL_ROLES_VALUE | Role

export const ApprovalCommentsHeader: React.FC<Props> = ({
  title,
  roleFilter,
  onRoleFilterChange,
}) => {
  const t = useTranslate({
    allRoles: 'salary.all-roles',
    driver: 'common.driver',
    leder: 'salary.leder',
  })

  const roleItems = [
    { value: ALL_ROLES_VALUE, label: t.allRoles },
    { value: 'driver', label: t.driver },
    { value: 'leder', label: t.leder },
  ] as const

  return (
    <div className="flex flex-col gap-3 border-b border-[#E1E1E1] px-6 py-5 md:flex-row md:items-center md:justify-between md:gap-4">
      <h2 className="m-0 text-lg font-bold text-[#363639]">{title}</h2>
      <div className="w-40 shrink-0">
        <Combobox<RoleSelectValue>
          mode="single"
          value={roleFilter ?? ALL_ROLES_VALUE}
          items={[...roleItems]}
          noSearch
          className="min-w-0"
          onChange={value =>
            onRoleFilterChange(value === ALL_ROLES_VALUE ? null : value)
          }
        />
      </div>
    </div>
  )
}
